import { AudioPlayerContext } from '../components/AudioPlayerProvider';
import { useContext } from 'react';
export var useAudioPlayerContext = function () {
    var context = useContext(AudioPlayerContext);
    return context;
};
